
async function getCsrfToken() {
  const res = await fetch(SERVER_URL + '/api/csrf', {
    credentials: 'include'
  }).then(res => res.json());
  if (res.code !== 0) {
    throw new Error(`Cannot get CSRF token: ${res.message} (Error #${res.code})`);
  }
  return res.data;
}

async function getStatus() {
  const res = await fetch(SERVER_URL + '/api/status', {
    credentials: 'include'
  });
  return res.json();
}

async function logout() {
  const token = await getCsrfToken();
  const res = await fetch(SERVER_URL + '/api/logout', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': token
    }
  }).then(res => res.json());
  if (res.code !== 0) {
    throw new Error(`Cannot logout: ${res.message} (Error #${res.code})`);
  }
  return res;
}

export default {
  getStatus,
  logout
};
